// extracted by css-extract-rspack-plugin
export default {"infoBanner":"info-banner-module__infoBanner___MKIDM","message":"info-banner-module__message___kQGWl"};